import { ISurvey } from '../allSurvey/types';
import {
  SET_TEST_NAME,
  SET_TEST_TYPE,
  SET_TEST_WELCOME,
  SET_TEST_FINAL,
  SET_TEST_TAGS,
  SET_TEST_ID,
  CLEAR_TEST,
  SET_TEST_ALL_DATA,
  SET_TEST_SCORE,
  SET_SHOW_ANSWERS,
  SET_SHOW_POINTS,
  SET_CRON_STARTED,
  SET_CRON_FINISHED,
  SET_TYPE_COUNTER,
} from './constants';
import { FinalItem, TagsType, WelcomeItem } from './types';

export const setTestAllData = (data: ISurvey) => (dispatch: any) => {
  dispatch({ type: SET_TEST_ALL_DATA, payload: data });
};

export const setTestDataName = (name: string) => (dispatch: any) => {
  dispatch({ type: SET_TEST_NAME, payload: name });
};

export const setTestDataType = (type: number) => (dispatch: any) => {
  dispatch({ type: SET_TEST_TYPE, payload: type });
};

export const setTestDataWelcome = (data: WelcomeItem) => (dispatch: any) => {
  dispatch({ type: SET_TEST_WELCOME, payload: data });
};

export const setTestDataFinal = (data: FinalItem) => (dispatch: any) => {
  dispatch({ type: SET_TEST_FINAL, payload: data });
};

export const setTestDataTags = (tag: TagsType[]) => (dispatch: any) => {
  dispatch({ type: SET_TEST_TAGS, payload: tag });
};

export const setTestDataId = (id: number) => (dispatch: any) => {
  dispatch({ type: SET_TEST_ID, payload: id });
};

export const setTestScore = (data: number) => (dispatch: any) => {
  dispatch({ type: SET_TEST_SCORE, payload: data });
};

export const clearTestData = () => (dispatch: any) => {
  dispatch({ type: CLEAR_TEST });
};

export const setShowAnswers = (data: boolean) => (dispatch: any) => {
  dispatch({ type: SET_SHOW_ANSWERS, payload: data });
};

export const setShowPoints = (data: boolean) => (dispatch: any) => {
  dispatch({ type: SET_SHOW_POINTS, payload: data });
};

export const setCronStarted = (date: Date | null) => (dispatch: any) => {
  dispatch({ type: SET_CRON_STARTED, payload: date });
};

export const setCronFinished = (date: Date | null) => (dispatch: any) => {
  dispatch({ type: SET_CRON_FINISHED, payload: date });
};

export const setTypeCounter = (type: number) => (dispatch: any) => {
  dispatch({ type: SET_TYPE_COUNTER, payload: type });
};
